import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import range from 'lodash/range';
import round from 'lodash/round';
import numericInput from '../../../../../lib/numericInput';
import s from '../../../../../redux/selectors';
import { wrap, withT } from '../../../../../lib/wrappers';

import units from '../../../../../lib/units';
import InlineInput from '../InlineInput';
import InlineSelect from '../InlineSelect';

const toiletFlowOptions = isMetric => range(1, 5.5, 0.5).map(value => ({
  value: round(isMetric ? units.galToLt(value) : value, 1),
  display: numericInput.format(isMetric ? units.galToLt(value) : value, { decimalPlaces: 1 }),
}));

const LowFlowToilet = ({
  t,
  isMetric,
}) => (
  <div className="action-details">
    <div className="action-details__form">
      <p>
        {t('I will replace')}
        <InlineInput
          maxLength={3}
          apiKey={'input_takeaction_low_flow_toilet_amount'}
        />
        {t('of my old')}
        <InlineSelect
          options={toiletFlowOptions(isMetric)}
          apiKey={'input_takeaction_low_flow_toilet_old'}
        />
        {t('{{volumeUnits}} per flush toilet(s) with a', {
          volumeUnits: isMetric ? t('liter') : t('gallon'),
        })}
        <InlineSelect
          options={toiletFlowOptions(isMetric)}
          apiKey={'input_takeaction_low_flow_toilet_new'}
        />
        {t('{{volumeUnits}} low-flush model that costs', {
          volumeUnits: isMetric ? t('liter') : t('gallon'),
        })}
        <InlineInput
          currency
          maxLength={6}
          apiKey={'input_takeaction_low_flow_toilet_cost'}
          period
        />
      </p>
    </div>
  </div>
);

LowFlowToilet.propTypes = {
  // wrapped
  t: PropTypes.func.isRequired,
  // connected props
  isMetric: PropTypes.bool.isRequired,
};

const mapStateToProps = (state, ownProps) => [
  'isMetric',
].reduce((props, selector) => ({
  ...props,
  [selector]: s[selector](state, ownProps),
}), {});

const mapDispatchToProps = (_dispatch, _ownProps) => ({});

export default wrap(
  withT('lowFlowToilet'),
  connect(mapStateToProps, mapDispatchToProps)(LowFlowToilet),
);
